import GroupService from "@/services/group.service.js";
import GroupFormatter from "@/helpers/formatters/group.formatter.js";

class GroupRepository {

    async getClientGroups() {
        const res = await GroupService.getClientGroups();
        return GroupFormatter.groupsFormat(res.data);
    }

    async getGroupsByClient(clientId) {
        const res = await GroupService.getGroupsByClient(clientId);
        return GroupFormatter.groupsFormat(res.data);
    }
}

export default new GroupRepository();